import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { messageColor } from 'types/ReferTypes'
import { response } from 'utils/apiUtil'

type ModalFileState = {
  openFile: boolean // ファイル取込画面を開いているかどうか
  file: any // ファイル
  fileName: string // ファイル名
  csvData: any // 出力CSV用データ(any)
  loading: boolean // ファイル取り込み中状態
  status: -1 | 1 | 0 // ステータス(-1: 処理前, 1: 成功, 0: 失敗)
  message: string // メッセージ
  messageColor: messageColor // メッセージの色
}

const initialState: ModalFileState = {
  openFile: false, // ファイル取込画面を開いているかどうか
  file: new File([new Blob()], 'name'), // ファイル型の初期値
  fileName: '', // ファイル名
  csvData: [],
  loading: false, // ファイル取り込み中状態
  status: -1,
  message: '', // メッセージ
  messageColor: 'red', // メッセージの色
}
export const ModalFileSlice = createSlice({
  name: 'ModalFile',
  initialState: initialState,
  reducers: {
    // モーダルを開く処理
    open: (state) => {
      state.openFile = true
    },
    // モーダルを閉じる処理
    close: (state) => {
      state.openFile = false
      state.file = new File([new Blob()], 'name') // ファイルは初期化する
    },
    startLoading: (state) => {
      state.loading = true
    },
    endLoading: (state) => {
      state.loading = false
    },
    // ファイル取り込み中状態を変更する処理
    changeLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    },
    // ステータスを変更する処理
    changeStatus: (state, action: PayloadAction<-1 | 1 | 0>) => {
      state.status = action.payload
    },
    // ファイルを変数に入れる処理
    changeFile: (state, action: PayloadAction<File>) => {
      state.file = action.payload
      state.fileName = action.payload.name
      state.message = initialState.message
    },
    // 出力CSV用データ(any)を変更する処理
    changeCSV: (state, action: PayloadAction<any>) => {
      state.csvData = action.payload
    },
    // ファイルを初期化する処理
    deleteFile: (state) => {
      state.file = initialState.file
    },
    // メッセージ変更(青字) //===========================//
    changeMessageSuccess: (state, action: PayloadAction<string>) => {
      state.message = action.payload
      state.messageColor = 'blue'
    },
    // メッセージ変更(赤字) //===========================//
    changeMessageError: (state, action: PayloadAction<string>) => {
      state.message = action.payload
      state.messageColor = 'red'
    },
    // メッセージ変更(APIレスポンスから設定) //===========================//
    changeMessage: (state, action: PayloadAction<response<any>>) => {
      const payload = action.payload
      state.message = payload.message
      state.messageColor = payload.error || payload.alert ? 'red' : 'blue'
    },
    // メッセージ変更(直接設定) //===========================//
    changeMessageDirect: (state, action: PayloadAction<{ message: string; color: messageColor }>) => {
      state.message = action.payload.message
      state.messageColor = action.payload.color
    },
    // CSV取込実行画面情報を初期化する処理
    format: (state) => {
      for (const key in state) {
        const tempKey: keyof ModalFileState = key as keyof ModalFileState
        ;(state as any)[tempKey] = initialState[tempKey]
      }
    },
  },
})

// actionCreator 書き忘れないこと！
export const {
  open, // モーダルを開く処理
  close, // モーダルを閉じる処理
  startLoading,
  endLoading,
  changeLoading, // ファイル取り込み中状態を変更する処理
  changeStatus, // ステータスを変更する処理
  changeFile, // ファイルを変数に入れる処理
  changeCSV, // 出力CSV用データ(any)を変更する処理
  deleteFile, // ファイルを初期化する処理
  changeMessageSuccess, // メッセージ変更(青字)
  changeMessageError, // メッセージ変更(赤字)
  changeMessage, // メッセージ変更(青字 or 赤字)
  format, // CSV取込実行画面情報を初期化する処理
} = ModalFileSlice.actions
export default ModalFileSlice.reducer
